import React from 'react'

import { Button, ButtonClean, List, Loader, Subsection } from '@fourthwall/components'

import * as S from './Headless.styled'
import { PublicTokenListItem } from './components/PublicTokenListItem/PublicTokenListItem'
import { useHeadless } from './hooks/useHeadless'

type PublicToken = {
  token: string
}

export const Headless = () => {
  const { handlePublicTokenCreate, handlePublicTokenDelete, loading, publicTokens } = useHeadless()

  return (
    <Subsection title="Storefront Token" id="storefront-token">
      <S.ContentContainer>
        <div>
          Build a fully custom storefront for your brand on any platform you choose, powered by our
          Storefront API.{' '}
          <ButtonClean
            label="Learn more"
            href="https://docs.fourthwall.com/storefront"
            target="_blank"
          />
        </div>
        <S.ActionsContainer>
          <div>
            <Button label="Create token" size="small" onClick={handlePublicTokenCreate} />
          </div>
          {loading && <Loader />}
          {!loading && !!publicTokens.length && (
            <List
              data={publicTokens}
              renderItem={(token: PublicToken) => (
                <PublicTokenListItem {...token} onDelete={handlePublicTokenDelete} />
              )}
            />
          )}
        </S.ActionsContainer>
      </S.ContentContainer>
    </Subsection>
  )
}
